import h from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import j from "../../../@babel/runtime/helpers/esm/toConsumableArray2.mjs";
import q from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
import U from "../../../@babel/runtime/helpers/esm/classCallCheck2.mjs";
import W from "../../../@babel/runtime/helpers/esm/createClass2.mjs";
import w from "../../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import { messages as T, newMessages as D } from "./messages.mjs";
import { warning as X, deepMerge as P, asyncMap as Z, format as R, convertFieldsError as z, complementError as _ } from "./util.mjs";
import A from "./validator/index.mjs";
var M = /* @__PURE__ */ function() {
  function g(r) {
    U(this, g), w(this, "rules", null), w(this, "_messages", T), this.define(r);
  }
  return W(g, [{
    key: "define",
    value: function(r) {
      var f = this;
      if (!r)
        throw new Error("Cannot configure a schema with no rules");
      if (q(r) !== "object" || Array.isArray(r))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(r).forEach(function(y) {
        var k = r[y];
        f.rules[y] = Array.isArray(k) ? k : [k];
      });
    }
  }, {
    key: "messages",
    value: function(r) {
      return r && (this._messages = P(D(), r)), this._messages;
    }
  }, {
    key: "validate",
    value: function(r) {
      var f = this, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, u = r, t = y, b = k;
      if (typeof t == "function" && (b = t, t = {}), !this.rules || Object.keys(this.rules).length === 0)
        return b && b(null, u), Promise.resolve(u);
      function B(a) {
        var i = [], e = {};
        function p(o) {
          if (Array.isArray(o)) {
            var n;
            i = (n = i).concat.apply(n, j(o));
          } else
            i.push(o);
        }
        for (var s = 0; s < a.length; s++)
          p(a[s]);
        i.length ? (e = z(i), b(i, e)) : b(null, u);
      }
      if (t.messages) {
        var O = this.messages();
        O === T && (O = D()), P(O, t.messages), t.messages = O;
      } else
        t.messages = this.messages();
      var F = {}, G = t.keys || Object.keys(this.rules);
      G.forEach(function(a) {
        var i = f.rules[a], e = u[a];
        i.forEach(function(p) {
          var s = p;
          typeof s.transform == "function" && (u === r && (u = h({}, u)), e = u[a] = s.transform(e), e != null && (s.type = s.type || (Array.isArray(e) ? "array" : q(e)))), typeof s == "function" ? s = {
            validator: s
          } : s = h({}, s), s.validator = f.getValidationMethod(s), s.validator && (s.field = a, s.fullField = s.fullField || a, s.type = f.getType(s), F[a] = F[a] || [], F[a].push({
            rule: s,
            value: e,
            source: u,
            field: a
          }));
        });
      });
      var H = {};
      return Z(F, t, function(a, i) {
        var e = a.rule, p = (e.type === "object" || e.type === "array") && (q(e.fields) === "object" || q(e.defaultField) === "object");
        p = p && (e.required || !e.required && a.value), e.field = a.field;
        function s(l, v) {
          return h(h({}, v), {}, {
            fullField: "".concat(e.fullField, ".").concat(l),
            fullFields: e.fullFields ? [].concat(j(e.fullFields), [l]) : [l]
          });
        }
        function o() {
          var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], v = Array.isArray(l) ? l : [l];
          !t.suppressWarning && v.length && g.warning("async-validator:", v), v.length && e.message !== void 0 && (v = [].concat(e.message));
          var m = v.map(_(e, u));
          if (t.first && m.length)
            return H[e.field] = 1, i(m);
          if (!p)
            i(m);
          else {
            if (e.required && !a.value)
              return e.message !== void 0 ? m = [].concat(e.message).map(_(e, u)) : t.error && (m = [t.error(e, R(t.messages.required, e.field))]), i(m);
            var E = {};
            e.defaultField && Object.keys(a.value).map(function(d) {
              E[d] = e.defaultField;
            }), E = h(h({}, E), a.rule.fields);
            var x = {};
            Object.keys(E).forEach(function(d) {
              var c = E[d], Q = Array.isArray(c) ? c : [c];
              x[d] = Q.map(s.bind(null, d));
            });
            var C = new g(x);
            C.messages(t.messages), a.rule.options && (a.rule.options.messages = t.messages, a.rule.options.error = t.error), C.validate(a.value, a.rule.options || t, function(d) {
              var c = [];
              m && m.length && c.push.apply(c, j(m)), d && d.length && c.push.apply(c, j(d)), i(c.length ? c : null);
            });
          }
        }
        var n;
        if (e.asyncValidator)
          n = e.asyncValidator(e, a.value, o, a.source, t);
        else if (e.validator) {
          try {
            n = e.validator(e, a.value, o, a.source, t);
          } catch (l) {
            var $, V;
            ($ = (V = console).error) === null || $ === void 0 || $.call(V, l), t.suppressValidatorError || setTimeout(function() {
              throw l;
            }, 0), o(l.message);
          }
          n === !0 ? o() : n === !1 ? o(typeof e.message == "function" ? e.message(e.fullField || e.field) : e.message || "".concat(e.fullField || e.field, " fails")) : n instanceof Array ? o(n) : n instanceof Error && o(n.message);
        }
        n && n.then && n.then(function() {
          return o();
        }, function(l) {
          return o(l);
        });
      }, function(a) {
        B(a);
      }, u);
    }
  }, {
    key: "getType",
    value: function(r) {
      if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !A.hasOwnProperty(r.type))
        throw new Error(R("Unknown rule type %s", r.type));
      return r.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(r) {
      if (typeof r.validator == "function")
        return r.validator;
      var f = Object.keys(r), y = f.indexOf("message");
      return y !== -1 && f.splice(y, 1), f.length === 1 && f[0] === "required" ? A.required : A[this.getType(r)] || void 0;
    }
  }]), g;
}();
w(M, "register", function(g, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  A[g] = r;
});
w(M, "warning", X);
w(M, "messages", T);
w(M, "validators", A);
export {
  M as default
};
//# sourceMappingURL=index.mjs.map
